import { Button } from "@/components/Button/Button";
import { Icon } from "@/components/Icon";
import * as gtag from "@/lib/gtag";
import { PageContext } from "pages/[[...slug]]";
import React, { useContext } from "react";
import ButtonPhone from "@/components/ButtonPhone/ButtonPhone";
import Badge from "@/components/Badge/Badge";
import Link from "next/link";

const CtaSectionCommerceBox = ({
  className = "",
  link,
  carOfferNumber,
  carMassAndWeightLink = "",
}) => {
  const { config } = useContext(PageContext);

  return (
    <div
      className={`container w-full flex lg:flex-nowrap flex-wrap justify-between items-center ${className} `}
    >
      <div
        className={`${
          carMassAndWeightLink ? "lg:w-[32%]" : "lg:w-[44%]"
        }  w-full flex flex-row  lg:pb-0 pb-6 lg:mb-0 mb-4 border-b-[1px] border-gray-300 lg:border-transparent`}
      >
        <div className="">
          <Badge color="success" className="lg:!text-2xl !text-sm px-6">
            auf Lager
          </Badge>
        </div>
        <div className="flex justify-start w-1/2 items-center">
          {carOfferNumber && (
            <p className="ml-[10%] text-gray-600 text-xs font-light whitespace-nowrap">
              Fahrzeug-ID {carOfferNumber}
            </p>
          )}
        </div>
      </div>
      {carMassAndWeightLink && (
        <div className="md:w-auto w-full md:order-[0] order-2  text-center">
          <Link href={carMassAndWeightLink}>
            <p className="text-blue-light hover:text-blue-medium cursor-pointer underline underline-offset-4 whitespace-nowrap pt-7 pb-4 lg:pb-0 lg:pt-0">
              Maße & Gewichte
            </p>
          </Link>
        </div>
      )}

      <div className="xl:w-1/4 lg:w-[22%] w-full lg:mt-0 mt-6">
        <ButtonPhone
          className="lg:!text-sm xl:!text-2xl hd:!text-3xl whitespace-nowrap"
          size="fullwidth"
          config={config}
          itemPosition="below"
        />
      </div>
      <div className="xl:w-1/4 lg:w-[22%] w-full lg:mt-0 mt-6">
        <Button
          size="fullwidth"
          as="a"
          rel="nofollow"
          className="cursor-pointer lg:!text-sm xl:!text-2xl hd:!text-3xl"
          href={link}
          onClick={() => {
            gtag.event({
              event: "itemClick",
              itemClick: "Request",
              itemPosition: "above",
            });
          }}
        >
          <Icon type="mail" className="w-6 h-6 mr-4" />
          Kauf anfragen
        </Button>
      </div>
    </div>
  );
};

export default CtaSectionCommerceBox;
